import styles from './Skeleton.module.scss';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

export function Skeleton({
  width = '100%',
  height = '1rem',
  borderRadius,
  className,
}: SkeletonProps) {
  const classes = [styles.skeleton, className].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      style={{ width, height, ...(borderRadius ? { borderRadius } : {}) }}
    />
  );
}

export default Skeleton;
